import store from "../store/index";

export default async (to, from, next) => {
    try {
        const project = await store.dispatch("projects/getProject", to.params.project_id);

        if (project) return next();
    } catch {}

    next({
        name: "projects_index",
        params: to.params
    });
};
